<template>
    <svg fill="rgb(78, 140, 255)" height="18" viewBox="0 0 15 18" width="15" xmlns="http://www.w3.org/2000/svg">
        <g fill-rule="nonzero">
            <path
                d="M7.5 8.222c1.145 0 2.136-.406 2.946-1.207.81-.8 1.22-1.78 1.22-2.911s-.41-2.11-1.22-2.912C9.636.392 8.645-.014 7.5-.014c-1.145 0-2.136.406-2.946 1.206-.81.8-1.22 1.78-1.22 2.912 0 1.131.41 2.11 1.22 2.911.81.8 1.801 1.207 2.946 1.207z"
            />
            <path
                d="M14.964 13.232a10.173 10.173 0 0 0-.146-1.108 8.54 8.54 0 0 0-.28-1.113 5.429 5.429 0 0 0-.469-1.038 3.932 3.932 0 0 0-.708-.9c-.28-.26-.622-.47-1.017-.622a3.596 3.596 0 0 0-1.299-.23c-.183 0-.36.074-.703.292-.211.134-.458.289-.734.46a4.256 4.256 0 0 1-.948.408 3.857 3.857 0 0 1-1.16.182 3.86 3.86 0 0 1-1.16-.182 4.246 4.246 0 0 1-.949-.408l-.734-.46c-.342-.218-.52-.291-.703-.291-.468 0-.904.077-1.299.229a3.132 3.132 0 0 0-1.017.623c-.267.249-.505.551-.708.899a5.44 5.44 0 0 0-.47 1.038 8.561 8.561 0 0 0-.278 1.113c-.073.393-.122.766-.146 1.108A14.64 14.64 0 0 0 0 14.267c0 .914.298 1.655.887 2.201.58.539 1.35.812 2.284.812h8.658c.934 0 1.703-.273 2.284-.812.589-.546.887-1.286.887-2.201 0-.354-.012-.702-.036-1.035z"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: "LoginUser",
};
</script>



// WEBPACK FOOTER //
// src/components/svg/LoginUser.vue